module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_DE-cd3a49b92e02e594d69f255d2e68c749.svg";